module.exports = __webpack_public_path__ + "img/herophone-mobileimage.2b3c665f.png";